import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
    {
        q: "Seminar ni percuma ke?",
        a: "Ya! Seminar ini adalah percuma. Pendaftaran diperlukan kerana tempat terhad kepada 100 peserta.",
    },
    {
        q: "Di mana lokasi seminar?",
        a: "Connexion Conference & Event Centre, Bangsar, Kuala Lumpur.",
    },
    {
        q: "Bila seminar berlangsung?",
        a: "31 October 2026, dari 8:30 AM hingga 5:00 PM.",
    },
    {
        q: "Macam mana nak daftar?",
        a: "Klik button Book My Free Seat dan PM admin Telegram untuk urusan pendaftaran.",
    },
    {
        q: "Ada lucky draw?",
        a: "Ya! 5 peserta bertuah berpeluang menerima Gold Wafer daripada HABIB, tertakluk kepada syarat penganjur.",
    },
];

const FAQ = () => (
    <section data-testid="faq-section" className="relative py-24 md:py-32">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal delay={0.05} className="flex flex-col items-center">
                <p className="text-center font-mono text-[11px] uppercase tracking-[0.25em] text-flame">
                    Soalan lazim
                </p>
                <h2 className="mt-5 text-center font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
                    PERSOALAN YANG <span className="text-chrome-grad">SELALU</span>{" "}
                    DITANYA
                </h2>
            </Reveal>

            <Reveal delay={0.1} className="mt-12 flex justify-center">
                <Accordion
                    type="single"
                    collapsible
                    className="w-full max-w-3xl"
                >
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            data-testid={`faq-item-${i + 1}`}
                            className="border-white/10"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i + 1}`}
                                className="py-6 text-left font-display text-base font-bold text-white transition-colors duration-300 hover:text-flame hover:no-underline md:text-lg"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm leading-relaxed text-white/65 md:text-base">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default FAQ;
